<div class="main-container">
  <div [ngClass]="{'singleToken': IssingleToken, 'multiToken': isMultiToken}">
    @for (d of screen; track d; let i = $index) {
      <div class=""
        [ngClass]="{'active': i==activeSlideIndex, 'inactive': i!=activeSlideIndex}">
        @for (r of d; track r) {
          <div class="token-screen-view ml-2 float-left"
            [ngStyle]="{'background-color': screen_data?.bg_color_code ? screen_data?.bg_color_code : '#0b3d91','width':calculateStyles(d.length)}"
            >
            <div class="header">
              <i class="fa-solid fa-user-doctor"></i>
              {{r.desk_name}}
            </div>
            @if (r.queueDeskMapping && r.queueDeskMapping.length > 0 && screen_data) {
              <!-- <div class="token-box text-center" *ngFor="let p of r.queueDeskMapping"
              [ngStyle]="{'background-color': screen_data?.bg_color_code ? screen_data?.bg_color_code : '#ffff'}">
              <div class="token-title" *ngIf="p.stage == 'Serving' && p.token">
              {{"field.label.token_number"|translate|async}}</div>
              <div class="token-number" [ngStyle]="{'font-size': 'calc(250px / ' + d.length + ')'}" *ngIf="p.stage == 'Serving' && p.token">{{p.token}}</div>
              <div class="upcoming-title" *ngIf="p.stage != 'Serving' && p.token">
              {{"upcmngtkn"|translate|async}}</div>
            </div>
            <div class="upcoming-tokens" >
              <span *ngIf="p.stage != 'Serving' && p.token">{{p.token}}</span>
            </div> -->
            <div class="token-box text-center"
              [ngStyle]="{'background-color': screen_data?.bg_color_code ? screen_data?.bg_color_code : '#ffff'}">
              @if (checkIfPresent(r.queueDeskMapping,'Serving')) {
                <div class="token-title">{{"field.label.token_number"|translate|async}}</div>
              }
              @for (p of r.queueDeskMapping; track p) {
                @if (p.stage == 'Serving' && p.token) {
                  <div [ngStyle]="{'font-size': 'calc(250px / ' + d.length + ')'}"
                    class="token-number">
                    {{p.token}}
                  </div>
                }
              }
              @if (checkIfPresent(r.queueDeskMapping,'Queue')) {
                <div class="upcoming-title">{{"upcmngtkn"|translate|async}}</div>
              }
              <div class="upcoming-tokens">
                @for (p of r.queueDeskMapping; track p) {
                  @if (p.stage != 'Serving' && p.token) {
                    <span>
                      {{p.token}}
                    </span>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
</div>